import clsx from 'clsx';
import React from 'react';
import { Icon, IconType } from '../../../../components/Icon';
import { Pill } from '../../../../components/Pill';

interface Props {
    icon?: IconType;
    label: React.ReactNode;
    url: string;
    additionalClasses?: string[];
    linkAdditionalClasses?: string[];
    attributes?: object;
    linkAttributes?: object;
    highlightNew?: boolean;
}

// FIXME: Just use common/components/MenuItemAction, it's the same thing.

export default function NavigationItem({
    url,
    icon,
    label,
    additionalClasses = [],
    linkAdditionalClasses = [],
    attributes = {},
    linkAttributes = {},
    highlightNew = false,
}: Props) {
    return (
        <li
            className={clsx(
                'menu__item__action',
                'menu__item__action--truncate',
                {
                    'menu__item__action--has-icon': Boolean(icon),
                    'menu__item__action--has-pill': Boolean(highlightNew),
                },
                ...additionalClasses
            )}
            {...attributes}
        >
            <a
                className={clsx('menu__item__action__link', ...linkAdditionalClasses)}
                href={url}
                {...linkAttributes}
            >
                {icon && (
                    <span className="menu__item__action__icon">
                        <Icon type={icon} />
                    </span>
                )}
                <span className="menu__item__action__label">{label}</span>
                {highlightNew && (
                    <span className={'menu__item__action__pill'}>
                        <Pill variations={['callout']}>New</Pill>
                    </span>
                )}
            </a>
        </li>
    );
}
